var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.609375,
    width: 29,
    height: 27.1969,
    rx: 6.60808,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.609375,
    width: 29,
    height: 27.1969,
    rx: 6.60808,
    stroke: "#E1E5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84608 19.8609C6.97813 19.8609 5.07081 17.8004 5.07081 14.6819C5.07081 11.5773 7.03382 9.47504 9.91569 9.47504C12.185 9.47504 13.9252 10.8255 14.3011 12.8859H12.8393C12.4634 11.5773 11.3357 10.7837 9.87392 10.7837C7.8413 10.7837 6.50478 12.3151 6.50478 14.668C6.50478 17.0208 7.8413 18.5522 9.87392 18.5522C11.3497 18.5522 12.5191 17.7587 12.895 16.5196H14.3429C13.9113 18.5244 12.1154 19.8609 9.84608 19.8609ZM19.2212 14.6819L15.7824 9.6421H17.4113L18.9845 11.8836C19.43 12.5379 19.7641 13.0948 20.0565 13.6517L22.7156 9.6421H24.2888L20.9197 14.668L24.3306 19.7078H22.7156L21.1703 17.4942C20.7805 16.9233 20.4046 16.3108 20.0704 15.726L17.3695 19.7078H15.7685L19.2212 14.6819Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/cx.047e7aabf2a9771970b37f5ecd82aabb.svg";
export { ForwardRef as ReactComponent };